import { UserRole } from "./constants/user.constants";

export interface LoginRequest {
  email: string;
  password: string;
}

// Password policy shared by API validation and the client form validator.
// Max 72 because bcrypt ignores anything beyond 72 bytes.
export const PASSWORD_MIN_LENGTH = 8;
export const PASSWORD_MAX_LENGTH = 72;
export const PASSWORD_REGEX =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9]).{8,72}$/;

/**
 * Public self-registration (email-first journey).
 * No password and no roles — the server forces roles: ['User'].
 */
export interface RegisterRequest {
  email: string;
  name: string;
  consent: boolean;
  /** Anti-bot honeypot; must be empty for real humans. */
  honeypot?: string;
}

/** Atomic verify + set-password from the email activation link. */
export interface ActivateRequest {
  token: string;
  password: string;
}

export interface ResendVerificationRequest {
  email: string;
}

/** Minimal, secret-free user shape returned on activation/auto-login. */
export interface AuthUser {
  _id: string;
  email: string;
  name: string;
  roles: UserRole[];
  isVerified: boolean;
}

export interface ActivateResponse {
  access_token: string;
  user: AuthUser;
}
